//create a new array of customer testimonials field; text, name, position
import HeroImage from './hero.png';

const Testimonials = [
	{
        text: 'I can highly recommend AllisWell Creative Studio for all your event needs in videography. We have worked with them on countless events since encountering them in 2019. Their videos are always outstanding and eye-catching. We will surely do business with them again and again.',
        name: 'Gabi',
        position: 'Founder of Army Creative Studios',
        Image: HeroImage,
    },
    {
        text: `AllisWell Creative Studio is a budding young brand dedicated to premium excellence. This particular trait of theirs endeared us to them as their values resonated with ours. Working together at events is always a fun experience because mutual respect for each others craft & service prevails.`,
        name: 'David Smith',
        position: 'Founder of 1 Percent Network',
		Image: HeroImage,
    },
    {
        text: `AllisWell Creative studio has the best photography and videography experts that can bring your ideas to life with just a call away.`,
        name: 'Gideon Cakes',
        position: 'Founder of Cakes International ',
		Image: HeroImage,
    },
	{
		text: `AllisWell Creative Studio delivered exceptional videos from our entire marriage ceremony, right from the pre-wedding shoot till the wedding reception. We were very impressed with the fact that they managed to capture iconic moments during all events. They are true professionals.`,
		name: `Emmanuel Anti`,
		position: `Creative Director`,
		Image: HeroImage,
	}
];

export default Testimonials